module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'primary': '#5F4F43',
                    'secondary': '#FEAE00',
                    'gray': '#404040',
                    'light-gray': '#525252',
                    'neutral-light': '#E5E5E5',
                    'very-light-gray': '#f5f5f5',
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('tailwind-scrollbar'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
